<template>
  <DialogHeader>
    <div
      class="size-[30px] rounded-full bg-red-200/50 flex items-center justify-center mr-2.5"
    >
      <Icon name="Alert" :size="16" class="stroke-red-700" />
    </div>
    <div>Cannot delete folder</div>
  </DialogHeader>
  <DialogContent>
    You are not able to delete a folder that contains files. To delete this
    folder, please move the files outside of this folder.
  </DialogContent>
  <DialogFooter>
    <UiButton class="w-full tablet-h:w-auto" primary @click="close()">
      Okay
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { Icon, UiButton } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'

const { close } = useDialog()
</script>
